export default function () {
  const modals = document.querySelectorAll("[data-modal]");
  const toggleBtns = document.querySelectorAll<HTMLElement>("[data-modal-toggle]");
  const closeBtns = document.querySelectorAll("[data-modal-close]");

  const closeModal = () => {
    modals.forEach((modal) => {
      modal?.classList.remove("flex");
      modal?.classList.add("hidden");
    });
    document.body.style.overflow = "auto";
  };
  const openModal = (id?: number | string) => {
    if (!id) return;
    closeModal();
    const modal = document.getElementById("modal-" + id);
    modal?.classList.add("flex");
    modal?.classList.remove("hidden");
    document.body.style.overflow = "hidden";
  };

  for (const modal of modals) {
    modal?.addEventListener("click", (e) => e.target === modal && closeModal());
  }
  for (const btn of toggleBtns) {
    btn.addEventListener("click", () => openModal(btn.dataset.modalToggle));
  }
  for (const btn of closeBtns) {
    btn.addEventListener("click", closeModal);
  }
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });
}
